import { getUser } from '../actions/UsersActions'
import { UserRole } from "../enums/UserRole";
import { ACTION_TYPE } from "../actions/ActionTypes";

export default class Auth0 {
  accessToken;
  expiresAt;
  userProfile;
  tokenId;

  constructor() {
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.renewSession = this.renewSession.bind(this);
    this.setSession = this.setSession.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.getUserProfile = this.getUserProfile.bind(this);
    this.getTokenExpirationDate = this.getTokenExpirationDate.bind(this);
    this.cleanSession = this.cleanSession.bind(this);
  }

  getUserId(user) {
    
    let ca = user.token.id_token;
    let base64Url = ca.split('.')[1];
    let decodedData = Buffer.from(base64Url, 'base64').toString('ascii');

    let decodedValue = JSON.parse(decodedData);
    let user_id = decodedValue.sub;

    return user_id
  };

  
  
  getAccessToken() {
    return this.accessToken;
  }

  getUserProfile() {
    return this.userProfile;
  }

  getTokenExpirationDate() {
    return this.expiresAt;
  }

  getTokenId() {
    return this.tokenId;
  }

  login(context) {
    if (context === "auth") window.location = `${process.env.REACT_APP_API_URL}/auth/users/login`;
    else if (context === "okta") window.location = `${process.env.REACT_APP_API_URL}/auth/admin/login`;
  }

  handleAuthentication(authData, history, dispatch) {
    if (authData && authData.type === "auth0") {
      if (authData.token.access_token && authData.user && authData.user.app_metadata && authData.user.app_metadata.authorized) {
        this.setSession(authData, history, dispatch);
      } else {
        dispatch({ type: 'OPEN_ERROR', payload: "Unauthorized user" });
        history.push('/unauthorized');
      }
    } else if (authData && authData.type === "okta") {
      if (!authData.error && authData.tokenset.access_token && authData.user && authData.user.roles.includes("admin")) {
        this.setOktaSession(authData, history, dispatch);
      } else if (authData.idToken && authData.error) {
        const returnToUrl = window.location.origin;
        history.push('/unauthorized');
        setTimeout(() => {
          window.location.href = `https://${process.env.REACT_APP_OKTA_DOMAIN}/oauth2/${process.env.REACT_APP_OKTA_CLIENT_ID}/v1/logout?id_token_hint=${authData.idToken}&post_logout_redirect_uri=${returnToUrl}`;
        }, 2000);
      } else {
        dispatch({ type: 'OPEN_ERROR', payload: "Unauthorized user" });
        history.push('/unauthorized');
      }
    } else {
      history.push('/');
    }
  }

  async setSession(authData, history, dispatch) {
    let alreadyAuthenticated = false;

    if (localStorage.getItem('isAuthenticated') === 'true' && localStorage.getItem('access_token') && this.isAuthenticated()) {
      alreadyAuthenticated = true;
    }
    // Set the time that the access token will expire at
    const username = authData.user.user_metadata.username;
    const expiresAt = (authData.token.expires_in * 1000) + new Date().getTime();
    this.accessToken = authData.token.access_token;
    this.expiresAt = expiresAt;
    this.userProfile = authData.user;

    // Set isAuthenticated flag in localStorage
    localStorage.setItem('isAuthenticated', true);
    localStorage.setItem('access_token', this.accessToken);
    localStorage.setItem('expires_at', this.expiresAt);
    let auth0UserId = this.getUserId(authData);

    let userId = auth0UserId.split('|')[1]
    let user = await getUser(userId);
    user.roles = user.app_metadata.roles;

    dispatch({ type: ACTION_TYPE.DASHBOARD.RESET_LAST_DASHBOARD_LOAD });
    dispatch({ type: "RESET_LAST_CERTIFICATES_DATA_LOAD" });
    dispatch({ type: 'LOGIN_SUCCESS', payload: { username, isAuthenticated: true, user: user } });

    // navigate to the home route
    if (authData.user.roles.includes(UserRole.CUSTOMER_OF_CUSTOMER)) {
      history.push('/transport_certificates');
    } else if (alreadyAuthenticated) {
      history.push(history.location.pathname);
    } else {
      if (authData.user.roles.includes(UserRole.SUPER_ADMIN)) {
        history.push('/organizations');
      } else {
        history.push('/dashboard');
      }
    }
  };

  setOktaSession(authData, history, dispatch) {
    let alreadyAuthenticated = false;

    if (localStorage.getItem('isAuthenticated') === 'true' && localStorage.getItem('access_token') && this.isAuthenticated()) {
      alreadyAuthenticated = true;
    }
    // Set the time that the access token will expire at
    const username = authData.user.name;
    const expiresAt = (authData.tokenset.expires_at * 1000) + new Date().getTime();
    this.accessToken = authData.tokenset.access_token;
    this.expiresAt = expiresAt;
    this.userProfile = authData.user;
    this.tokenId = authData.tokenset.id_token;

    // Set isAuthenticated flag in localStorage
    localStorage.setItem('isAuthenticated', true);
    localStorage.setItem('access_token', this.accessToken);
    localStorage.setItem('expires_at', this.expiresAt);

    dispatch({ type: 'LOGIN_SUCCESS', payload: { username, isAuthenticated: true, user: this.userProfile } });

    // navigate to the home route
    if (authData.user.roles.includes(UserRole.CUSTOMER_OF_CUSTOMER)) {
      history.push('/transport_certificates');
    } else if (alreadyAuthenticated) {
      history.push(history.location.pathname);
    } else {
      if (authData.user.roles.includes(UserRole.SUPER_ADMIN)) {
        history.push('/organizations');
      } else {
        history.push('/dashboard');
      }
    }
  };

  async renewSession(cookies, history, dispatch) {
    try {
      let response = await fetch( `${process.env.REACT_APP_API_URL}/auth/users/profile`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        } 
      });

      if (!response.ok) throw Error(response.statusText);
      
      let data = await response.json();

      if (data.type === "auth0") {
        this.setSession(data, history, dispatch);
      } else if (data.type === "okta") {
        this.setOktaSession(data, history, dispatch);
      }
    } 
    catch (error) {
      console.log(error);
      this.logout(cookies, dispatch);
    }
  }

  async logout(cookies, dispatch) {
    let tokenId = null

    if (this.tokenId) {
      tokenId = this.tokenId;
      try {
        let response = await fetch( `${process.env.REACT_APP_API_URL}/auth/admin/logout`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json; charset=utf-8"
          } 
        });
  
        if (!response.ok) throw Error(response.statusText);
      } 
      catch (error) {
        console.log(error);
        this.logout(cookies, dispatch);
      }
    } else {

      try {
        let response = await fetch( `${process.env.REACT_APP_API_URL}/auth/users/logout`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json; charset=utf-8"
          } 
        });
  
        if (!response.ok) throw Error(response.statusText);
      } 
      catch (error) {
        console.log(error);
        this.logout(cookies, dispatch);
      }
    }

    this.cleanSession(cookies);
    dispatch({ type: 'LOGOUT_START' });
    dispatch({ type: "RESET_LAST_CERTIFICATES_DATA_LOAD" });
    dispatch({ type: ACTION_TYPE.DASHBOARD.RESET_LAST_DASHBOARD_LOAD });

    let returnToUrl = `${window.location.origin}`;

    if ((process.env.REACT_APP_API_URL).includes('localhost'))
    {
      returnToUrl = `${window.location.origin}`;
    }
    else if ((process.env.REACT_APP_API_URL).includes('staging'))
    {
      returnToUrl = `${window.location.origin}`;
    }
    else
    {
      returnToUrl = `https://theenergyorigin.com`;
    }

    if (tokenId) {
      window.location.href = `https://${process.env.REACT_APP_OKTA_DOMAIN}/oauth2/${process.env.REACT_APP_OKTA_CLIENT_ID}/v1/logout?id_token_hint=${tokenId}&post_logout_redirect_uri=${returnToUrl}`;
      tokenId = null;
    } else {
      window.location.href = `https://${process.env.REACT_APP_AUTH_DOMAIN}/v2/logout?returnTo=${returnToUrl}&client_id=${process.env.REACT_APP_AUTH_CLIENT_ID}`;
    }
  }

  cleanSession(cookies) {

    this.accessToken = null;
    this.expiresAt = 0;
    this.userProfile = null;
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('access_token');
    localStorage.removeItem('expires_at');
    cookies.remove('session');
    cookies.remove('session.sig');
    localStorage.clear();
  }

  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    if (this.expiresAt === undefined && localStorage.getItem("expires_at") !== null) {
      this.expiresAt = localStorage.getItem("expires_at")
    };
    return new Date().getTime() < this.expiresAt;
  }

}



// WEBPACK FOOTER //
// ./src/auth/Auth.js